import React from 'react'
import Withdrawal from '@commons/withdraw'

const WithdrawalRejected = () => {
  return <Withdrawal status={'Rejected'} />
}

export default WithdrawalRejected
